import React from 'react'
import styles from './SearchableCard.scss'
import { featureNames, searchResultsText } from 'lib/localization'
import cx from 'classnames'
import { injectIntl } from 'react-intl'

class _SearchableCard extends React.PureComponent {
  render () {
    const { keywords, onKeywordChange, children, className, chips, resultsCount, resultsLength, placeholder, intl, ...props } = this.props

    return (
      <div {...props} className={cx(styles.SearchableCard, className)}>
        <div className={styles.searchContainer}>
          <input
            spellCheck='false'
            type='text'
            className={styles.searchInput}
            placeholder={placeholder ?? intl.formatMessage(featureNames.search)}
            value={keywords}
            onChange={onKeywordChange} />
          {chips && <div className={styles.chips}>
            {chips}
          </div>}
          {keywords &&
            resultsCount !== undefined &&
            resultsLength !== undefined &&
            <div className={styles.resultsCount}>
              {searchResultsText(resultsLength, resultsCount)}
            </div>}
        </div>
        <div className={styles.resultsContainer}>
          {children}
        </div>
      </div>
    )
  }
}

export const SearchableCard = injectIntl(_SearchableCard)
